export default "__VITE_ASSET__BN47pPEW__"